import { useSelector } from "react-redux";
import UpdatesCard from "./UpdatesCard";
import SmallLoading from "../../../globalComponents/Loading/components/SmallLoading/SmallLoading";

const UpdatesData = () => {
  const { allUpdates, loading } = useSelector((state) => state.updatesData);

  console.log(allUpdates, "updates");

  const tableHead = [
    { id: 1, label: "Yeniləmə edən" },
    // { id: 2, label: "Qəbul edən" },
    // {
    //   id: 3,
    //   label: "Göndərilmə tarixi",
    // },
    {
      id: 4,
      label: "Yenilənmə tarixi",
    },
    {
      id: 5,
      label: "Status",
    },
    {
      id: 6,
      label: "",
    },
  ];

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <SmallLoading />
      </div>
    );
  }

  console.log(loading, "LLLLLLLLLLLLLLLLLLLLLoading");

  return (
    <>
      <table className={`details-table updates   courses-table`}>
        <thead>
          <tr>
            {tableHead.map((head, i) => (
              <th key={i}>{head.label}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {allUpdates?.map((item, i) => (
            <UpdatesCard
              key={item._id}
              data={item}
              mode="desktop"
              cellNumber={i + 1}
            />
          ))}
        </tbody>
      </table>
    </>
  );
};

export default UpdatesData;
